import React from 'react';
import PropTypes from 'prop-types';
import Container from '../Container';

const propTypes = {
  fish: PropTypes.shape({
    name: PropTypes.string,
    route: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
};

const defaultProps = {
};

function FishDetail({
  fish: {
    name,
    image,
  },
}) {
  return (
    <div className="FishDetail">
      <Container>
        <h1>
          {name}
        </h1>

        <img src={image} alt={name} />
      </Container>
    </div>
  );
}

FishDetail.propTypes = propTypes;
FishDetail.defaultProps = defaultProps;

export default FishDetail;



// WEBPACK FOOTER //
// ./src/Components/FishDetail/index.jsx